// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';

import actions from '../../action-list';
import {postPin} from '../../shared/repositories';
import {readClaimProduct} from './get-product-details';
import {successAlertBar} from '../../../shared/services/alert-bar';
import {translate} from '../../../shared/services/translation-service';
import {updateNonTrackedPinModalVisibility} from './non-tracked-pin-modal-visibility';

export const createPin = pin =>

    async (dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            await postPin(pin);

            successAlertBar(translate('PIN_CREATED_SUCCESSFULLY'));

            updateNonTrackedPinModalVisibility(false)(dispatch);

            dispatch({
                type: actions.RESET_CLAIM_INCENTIVE_CREATE_PIN_MODAL_PIN
            });

            readClaimProduct(pin.pin)(dispatch, getState);

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/incentive/action-creators/create-pin.js